{
  "title": "Flame Strike",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level evocation",
  "level": 5,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (pinch of sulfur)",
  "duration": "Instantaneous",
  "description": [
    "A vertical column of divine fire roars down from the heavens in a location you specify. Each creature in a 10-foot radius, 40-foot-high cylinder centered on a point within range must make a Dexterity saving throw. A creature takes 4d6 fire damage and 4d6 radiant damage on a failed save, or half as much damage on a successful one.",
    "At Higher Levels. When you cast this spell using a spell slot of 6th level or higher, the fire damage or the radiant damage (your choice) increases by 1d6 for each slot level above 5th."
  ],
  "spellLists": ["cleric"]
}
